// Centralised toast helpers for Nivo CRM (Phase 9).
//
// Standard rules (see brief):
// - Success:  vert, coin haut-droit, disparaît après 3 s. Icône Check.
// - Erreur:   rouge, coin haut-droit, disparaît après 5 s. Icône X.
// - Réseau/5xx: "Connexion perdue. Réessayez." avec bouton d'action retry.
// - Changement de statut de commande (exception client): coin BAS-DROIT,
//   très discret, 2 s max — pour ne pas interrompre le flux des agents.
//
// Colors are enforced inline (not via sonner theme tokens) so the
// look stays consistent even when this module is imported in isolation
// (e.g. from a modal or a test).
import { toast } from 'sonner';

const SUCCESS_STYLE = {
    background: '#10B981',
    color: '#FFFFFF',
    border: '1px solid #10B981',
};

const ERROR_STYLE = {
    background: '#EF4444',
    color: '#FFFFFF',
    border: '1px solid #EF4444',
};

// Discrete status-change toast: neutral dark chip, non-intrusive.
const STATUS_STYLE = {
    background: 'rgba(26,29,46,0.92)',
    color: '#FFFFFF',
    border: '1px solid rgba(26,29,46,0.92)',
    fontSize: '13px',
};

export function toastSuccess(message, opts = {}) {
    return toast.success(message, {
        duration: 3000,
        position: 'top-right',
        style: SUCCESS_STYLE,
        ...opts,
    });
}

export function toastError(message, opts = {}) {
    return toast.error(message, {
        duration: 5000,
        position: 'top-right',
        style: ERROR_STYLE,
        ...opts,
    });
}

// Called by API helpers when the network request fails (offline / CORS
// error / 5xx). Optionally shows a "Réessayer" action button which calls
// `onRetry()` when clicked.
export function toastNetworkError(onRetry) {
    return toast.error('Connexion perdue. Réessayez.', {
        duration: 6000,
        position: 'top-right',
        style: ERROR_STYLE,
        action: typeof onRetry === 'function'
            ? { label: 'Réessayer', onClick: () => onRetry() }
            : undefined,
    });
}

// Order-status change toast — discrete, bottom-right, 2 s.
export function toastStatusChange(message) {
    return toast(message, {
        duration: 2000,
        position: 'bottom-right',
        style: STATUS_STYLE,
    });
}

// Expose sonner's raw `toast` for edge cases (dismiss, promise wrappers, etc.).
export { toast };
